import { Input } from 'common/InputForm'
import { CustomModal } from 'components/modals/ModalBox'
import useButtonLoader from 'hooks/useButtonLoader';
import React, { useState } from 'react'
import { changePasswordSubAdminApi } from 'services/subAdmin';
import { toastMessage } from 'utils/toastMessage';

const UpdatePassword = ({ show, close, selectedData, listing = () => { } }) => {
    const [error, setError] = useState({});
    const [buttonLoader, setButtonLoader] = useButtonLoader("Add");
    const [input, setInput] = useState({
        oldPassword: '',
        password: "",
        confirmPassword: '',
    })
    // -----------close-modal----------------
    const modalClose = () => {
        close()
        setInput({})
        setError({})
    }

    // -----------handle-onchange----------------
    const handleChange = (e) => {
        const { name, value } = e.target;
        const noSpace = value.replace(/\s+/g, '');
        setInput({ ...input, [name]: noSpace });
    };
    // ------------validation-----------------
    const validation = () => {
        let errorMessage = {};
        let status = true;

        if (!input.oldPassword) {
            errorMessage['oldPassword'] = 'Please enter old password';
            status = false;
        }

        if (!input.password) {
            errorMessage['password'] = 'Please enter new password';
            status = false;
        }

        if (!input.confirmPassword) {
            errorMessage['confirmPassword'] = 'Please enter confirm Password';
            status = false;
        }
        if (input.confirmPassword !== input.password) {
            toastMessage('New Password and Confirm Password do not match. Please enter the same password.', "error", 'mismatch');
            status = false;
        }



        setError(errorMessage);
        return status;
    };
    // ------------update-password-API--------------------
    const updatePassword = async () => {
        if (validation()) {
            try {
                const payLoad = {
                    adminId: selectedData?._id,
                    oldPassword: input?.oldPassword,
                    password: input?.confirmPassword,
                }
                setButtonLoader(true)
                const res = await changePasswordSubAdminApi(payLoad)
                const { code, message } = res?.data;
                if (code === 200) {
                    toastMessage(message, 'success', 'updateSubAdminPassword')
                    modalClose()
                }
            } catch (e) {
                console.log('e', e)
            } finally {
                setButtonLoader(false)
            }
        }
    }
    return (
        <CustomModal
            className={"add_model"}
            show={show}
            handleClose={modalClose}
        >
            <h3>Change Password</h3>

            <div className="form_field">
                <Input
                    type="text"
                    label="Old Password"
                    placeholder="Enter old password"
                    name="oldPassword"
                    maxLength={25}
                    value={input?.oldPassword}
                    onChange={handleChange}
                    error={error.oldPassword}
                />
            </div>
            <div className="form_field">
                <Input
                    type="text"
                    label="New Password"
                    placeholder="Enter new password"
                    name="password"
                    maxLength={25}
                    value={input?.password}
                    onChange={handleChange}
                    error={error.password}
                />
            </div>
            <div className="form_field">
                <Input
                    type="text"
                    label="Confirm Password"
                    placeholder="Enter confirm password"
                    name="confirmPassword"
                    maxLength={25}
                    value={input?.confirmPassword}
                    onChange={handleChange}
                    error={error.confirmPassword}
                />
            </div>

            <div className="button_wrap">
                <button
                    type="button"
                    className="button light"
                    onClick={modalClose}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    ref={buttonLoader}
                    onClick={updatePassword}
                    className="button"
                >
                    Submit
                </button>
            </div>
        </CustomModal>
    )
}

export default UpdatePassword